import React from 'react'
import { Route } from 'react-router'
import getPath from '../shared/utils/getPath'
import RootContainer from './containers/Root'
import FormContainer from './containers/Form'

const userRoutes = (
  <Route
    component={RootContainer}
    key="user-routes"
    path={getPath('backend', '/user')}
  >
    <Route
      path={getPath('backend', '/user/create')}
      component={FormContainer}
    />
    <Route
      path={getPath('backend', '/user/:id/edit')}
      component={FormContainer}
    />
  </Route>
)

export default userRoutes



// WEBPACK FOOTER //
// ./src/user/routes.js